var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticStyle:{"text-align":"left"},attrs:{"no-gutters":""}},[_c('MarkdownViewer',{attrs:{"content":_vm.mdText,"flat":true,"outlined":false,"elevation":0,"transparent":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }